import { Typography, withStyles, Tooltip, Button } from '@material-ui/core';
import React from 'react'
import { compose } from 'recompose';
import withErrorCatcher from '../Common/withErrorCatcher';
import Star from '@material-ui/icons/Star';
import { connect } from 'react-redux';
import EmailIcon, { EmailIconPX } from '../Common/Icons/ProfileIcons/EmailIcon';
import LanguageIcon from '../Common/Icons/ProfileIcons/LanguageIcon';
import NicknameIcon from '../Common/Icons/ProfileIcons/NicknameIcon';
// import PhoneIcon from '@material-ui/icons/Phone'
import PhoneIcon from '../Common/Icons/UserIcons/PhoneIcon';
import MessageIcon from '../Common/Icons/UserIcons/MessageIcon';
import SubscribeIcon from '../Common/Icons/UserIcons/SubscribeIcon';
import UnsubscribeIcon from '../Common/Icons/UserIcons/UnsubscribeIcon';
import { hexToRGB } from '../../views/groups/Calendar/event-utils';
import parseImagUrl from "../../../ui/components/Common/parseImagUrl";
import { useTranslation } from 'react-i18next';
import { OnelineDateIconPX } from '../Common/Icons/ProfileIcons/OnelineDateIcon';
import { PhoneIconPX } from '../Common/Icons/ProfileIcons/PhoneIcon';
import BirthdayIcon, { BirthdayIconPX } from '../Common/Icons/ActionCenter/BirthdayIcon';
import moment from 'moment';
import {useGetUserData} from '@tuqqi/web'

const styles = theme => {
    const primaryColor = theme.customColors.primary.b300
    const lighterColor = hexToRGB(primaryColor, 0.1)
    const primaryColor09Opacity = hexToRGB(primaryColor, 0.999)

return ({
    header: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        width: '86%',
        marginBottom: 8,
        marginLeft: 8,
        marginTop: 16,
        marginRight: 8,
    },
    headerSmall: {
        width: 'auto!important',
        marginLeft: 'auto!important',
        marginRight: 'auto!important',
    },
    titles: {
        marginLeft: 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        // margin: 16,
        marginBottom: 0,
        marginTop: 0,
        // padding: '0 16px',
    },
    containerSmall: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    img: {
        width: 88,
        height: 88,
        borderRadius: '50%',
        marginBottom: 16
    },
    imgSmall: {
        width: 36,
        height: 36,
        borderRadius: 8,
        objectFit: 'cover'
    },
    title: {
        fontFamily: 'Rubik',
        fontSize: 16,
        fontWeight: '500',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '24px',
        color: '#18181B',
        display: 'block',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'pre',
        maxWidth: 136,
    },
    aboutText: {
        fontFamily: 'Rubik',
        fontSize: 14,
        fontWeight: '500',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '20px',
        color: '#18181B',
        display: 'block',
    },
    about: {
        marginRight: 'auto',
        marginLeft: 16,
        marginBottom: 8,
    },
    bio: {
        borderRadius: 8,
        marginRight: 16,
        marginLeft: 16,
        padding: 8,
        width: '-webkit-fill-available',
        background: "rgba(129, 140, 248, 0.10)",
    },
    bioText: {
        fontFamily: 'Rubik',
        fontSize: 13,
        fontWeight: '400',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '16px',
        color: '#3F4046',
        display: 'block',
    },
    subtitle: {
        display: 'block',
        fontFamily: 'Rubik',
        fontSize: 12,
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '12px',
        letterSpacing: '0.4px',
        color: "#6B6F7A",
        width: '100%',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'pre',
        maxWidth: 136,
    },
    pointsContainer: {
        marginTop: -5,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: 14,
    },
    starIcon: {
        display: 'flex',
        color: '#efc03e',
        width: 19,
        height: 19,
        fontSize: 19,
        marginRight: 6,
        marginTop: -1
    },
    points: {
        fontFamily: 'Rubik',
        fontSize: 12,
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: '0.4px',
        color: 'rgb(240, 204, 48)',
    },
    infoContainer: {
        borderRadius: 6,
        display: 'flex',
        height: 'fit-content',
        marginLeft: 30,
        marginRight: 16,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start'
    },
    infoContainerTooltipe: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
        width: '100%',
        marginBottom: -10
    },
    infoTitle: {
        width: '95%',
        fontFamily: 'Rubik',
        fontSize: 14,
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '20px',
        letterSpacing: '0.4px',
        color: '#6B6F7A',
        display: 'flex',
        alignItems: 'center',
        height: 32,

        '&:last-child': {
            marginBottom: 0
        },
    },
    infoTitleTooltipe: {
        fontFamily: 'Rubik',
        fontSize: 14,
        fontWeight: 'light',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1,
        letterSpacing: '0.4px',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        marginBottom: 12,
        position: 'relative',

        '&:last-child': {
            marginBottom: 0
        },
    },
    emailHolder: {
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
    },
    emailHolderBig: {
        width: '195px',
    },
    infoIconHolder: {
        marginTop: 6,
        marginRight: 10,
        color: '#979aaa',
    },
    infoIconHolderToolTipe: {
        color: '#fff',
        marginRight: 5,
        fontSize: 15
    },
    tooltip: {
        fontSize: 12,
        backgroundColor: '#4A4A4F',
        padding: '4px 8px',
        borderRadius: 4,
        fontfamily: 'Rubik',
        lineHeight: '16px',
    },
    triangle: {
        position: 'absolute',
        top: '50%',
        left: -3,
        marginTop: -3.5,
        transform: 'rotate(-45deg)',
        border: `solid 3px #4A4A4F`,
        borderRight: `3px solid transparent`,
        borderBottom: `3px solid transparent`,
        zIndex: '9999'
    },
    avatarImgHolderSmall: {
        width: '100%',
        textAlign: 'center'
    },
    drawerSmallButtons: {
        marginTop: 12,
        marginBottom: 24,
      },

      drawerButtons: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        margin: 24,
      },
      settingsButton: {
        height: 28,
        width: 83,
        marginLeft: 10,
        border: `1px solid ${theme.customColors.primary.b500}`,
        textTransform: 'none',
        fontFamily: 'Rubik',
        fontSize: 12,
        fontStyle: 'normal',
        fontWeight: 400,
        color: theme.customColors.primary.b500,
        borderRadius: 4,
        "&:hover": {
            backgroundColor:  lighterColor,
           
        },
    },
    divider: {
        background: 'rgba(183, 184, 189, 0.15)',
        height: 1,
        width: '-webkit-fill-available',
        marginTop: 8,
        marginBottom: 8,
    },
    settingsButtonColored: {
      height: 28,
      width: 83,
      textTransform: 'none',
      fontFamily: 'Rubik',
      fontSize: 12,
      fontStyle: 'normal',
      fontWeight: 400,
      color: 'white',
      backgroundColor: theme.customColors.primary.b500,
      borderRadius: 4,
      "&:hover": {
        backgroundColor: primaryColor09Opacity,
    },
  },

  smallButtonIcon: {
    width: 30,
    height: 28,
    border: `1px solid ${theme.customColors.primary.b500}`,
    textAlign: 'center',
    marginRight: 8,
    marginLeft: 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    borderRadius: 4,
    marginTop: 8,
    "&:hover": {
        backgroundColor:  lighterColor,
    },
  },
  smallColoredButtonIcon: {
    width: 32,
    height: 28,
    textAlign: 'center',
    marginRight: 8,
    marginLeft: 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    borderRadius: 4,
    marginTop: 8,
    backgroundColor: theme.customColors.primary.b500,
    "&:hover": {
        backgroundColor: primaryColor09Opacity,
    },
  },
  notAvailable: {
    fontFamily: 'Rubik',
    fontWeight: 400,
    fontSize: 11,
    lineHeight: '16px',
    letterSpacing: 0.4,
    color: '#B1B1B3',
  },
  messageIcon: {
    cursor: 'pointer',
    marginLeft: 'auto',
    marginRight: 0
  }
})
}

const MessageButton = () => {
    return <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 10.6C1 7.23969 1 5.55953 1.65396 4.27606C2.2292 3.14708 3.14708 2.2292 4.27606 1.65396C5.55953 1 7.23969 1 10.6 1H19.4C22.7603 1 24.4405 1 25.7239 1.65396C26.8529 2.2292 27.7708 3.14708 28.346 4.27606C29 5.55953 29 7.23969 29 10.6V19.4C29 22.7603 29 24.4405 28.346 25.7239C27.7708 26.8529 26.8529 27.7708 25.7239 28.346C24.4405 29 22.7603 29 19.4 29H10.6C7.23969 29 5.55953 29 4.27606 28.346C3.14708 27.7708 2.2292 26.8529 1.65396 25.7239C1 24.4405 1 22.7603 1 19.4V10.6Z" fill="white"/>
    <path d="M19.4 0.5H10.6H10.5769C8.91628 0.499998 7.63937 0.499997 6.6185 0.583406C5.58706 0.667677 4.77303 0.839577 4.04906 1.20846C2.82601 1.83163 1.83163 2.82601 1.20846 4.04906C0.839577 4.77303 0.667677 5.58706 0.583406 6.6185C0.499997 7.63937 0.499998 8.91628 0.5 10.5769V10.6V19.4V19.4231C0.499998 21.0837 0.499997 22.3606 0.583406 23.3815C0.667677 24.4129 0.839577 25.227 1.20846 25.9509C1.83163 27.174 2.82601 28.1684 4.04906 28.7915C4.77303 29.1604 5.58706 29.3323 6.6185 29.4166C7.63937 29.5 8.91627 29.5 10.5769 29.5H10.6H19.4H19.4231C21.0837 29.5 22.3606 29.5 23.3815 29.4166C24.4129 29.3323 25.227 29.1604 25.9509 28.7915C27.174 28.1684 28.1684 27.174 28.7915 25.9509C29.1604 25.227 29.3323 24.4129 29.4166 23.3815C29.5 22.3606 29.5 21.0837 29.5 19.4231V19.4V10.6V10.5769C29.5 8.91627 29.5 7.63937 29.4166 6.6185C29.3323 5.58706 29.1604 4.77303 28.7915 4.04906C28.1684 2.82601 27.174 1.83163 25.9509 1.20846C25.227 0.839577 24.4129 0.667677 23.3815 0.583406C22.3606 0.499997 21.0837 0.499998 19.4231 0.5H19.4Z" stroke="#B7B8BD" stroke-opacity="0.2"/>
    <path d="M12.4627 19.6012C12.6266 19.4159 12.8873 19.3502 13.1194 19.4356C13.7699 19.6751 14.4726 19.8 15.2 19.8C18.2178 19.8 20.6 17.645 20.6 15C20.6 12.355 18.2178 10.2 15.2 10.2C12.1822 10.2 9.79998 12.355 9.79998 15C9.79998 15.9686 10.1194 16.8935 10.7115 17.6792C10.7964 17.7918 10.8389 17.9307 10.8315 18.0715C10.8001 18.6761 10.5096 19.4995 9.96411 20.5791C11.1507 20.4867 11.9754 20.1523 12.4627 19.6012ZM9.59362 21.8002C9.42658 21.8053 9.2611 21.7669 9.11341 21.6887C8.6431 21.4396 8.46372 20.8565 8.71274 20.3862C9.22785 19.4133 9.52557 18.6743 9.60971 18.2028C8.95465 17.255 8.59998 16.1519 8.59998 15C8.59998 11.6639 11.5448 9 15.2 9C18.8552 9 21.8 11.6639 21.8 15C21.8 18.3361 18.8552 21 15.2 21C14.4656 21 13.7495 20.8929 13.0722 20.6855C12.2748 21.3907 11.1075 21.7542 9.59362 21.8002Z" fill="#6B6F7A"/>
    </svg>    
}

const __SelectedUserInfoDrawer = (props) => {
    const {selectedUser = [], classes, isDrawerOpen,additionalOptions,theme, isRemoved} = props
    const {birthday, creationDateTime, points, bio, profileImageUrl, auth0_id, firstname,lastname, tag, title, email, lang, phone } = selectedUser[0]
    const Points = (
        <div data-intrcm-id="UserInfoDrawer_umsrjksc" className={classes.pointsContainer}>
            <Star className={classes.starIcon}/>
            <Typography className={classes.points}>{`${points} pts.`}</Typography>
        </div>
    )

    const [t] = useTranslation('groupDrawerTranslate');
    const _bioText = !bio || bio === 'null' ? t("No bio yet") : bio
    const {isError, isLoading, user} = useGetUserData(auth0_id, true)

    const bioText = isError || isLoading || !user ? _bioText : (!user.bio || user.bio === 'null' ? t("No bio yet") : user.bio)
    const birthdayText = isError || isLoading || !user ? birthday : user.birthday


    const Info = ({content = false}) =>  {
        const titleStyles = content ? classes.infoTitleTooltipe : classes.infoTitle
        const iconHolderStyles = content ? classes.infoIconHolderToolTipe : classes.infoIconHolder
        const iconColor =  content ? '#fff': '#979AAA'
        
        return (<div data-intrcm-id="UserInfoDrawer_b4c5w9ui" className={content ? classes.infoContainerTooltipe : classes.infoContainer}>
            <Typography className={titleStyles} noWrap={true}>
                        <span className={iconHolderStyles}>
                            <EmailIconPX iconColor={iconColor}/>
                        </span>
                        {<span className={`${classes.emailHolder} ${classes.emailHolderBig}`}>{email}</span>}
                    </Typography>
                    <Typography className={titleStyles}>
                        <span className={iconHolderStyles}>
                            <OnelineDateIconPX iconColor={iconColor}/>
                        </span>
                        {moment(creationDateTime).format('LL') }
                    </Typography>
                    {phone && <Typography className={titleStyles}>
                        <span className={iconHolderStyles}>
                            <PhoneIconPX iconColor={iconColor}/>
                        </span>
                    {phone}
                    </Typography>}
                    {birthdayText && <Typography className={titleStyles}>
                        <span className={iconHolderStyles}>
                            <BirthdayIconPX iconColor={iconColor}/>
                        </span>
                        {moment(birthdayText).format('LL') }
                    </Typography>}
                    {content && <div data-intrcm-id="UserInfoDrawer_w9wcjyl9" className={classes.triangle}></div>}
                </div>)
    }

    const content = <Info content/>

    let photo = profileImageUrl ?? ''

    if(!photo.startsWith('https://')) {
        photo = parseImagUrl(props.cloudfront, photo, 120)
    }
    if(photo.includes("fit-in/50x0")) {
        photo = photo.replace("fit-in/50x0", "fit-in/120x0")
    }

    return (
        <div data-intrcm-id="UserInfoDrawer_ak0dbyml" className={isDrawerOpen ? classes.container : classes.containerSmall}>
                         <div className={`${classes.header} ${!isDrawerOpen ? classes.headerSmall : ""}`}>
                    <img alt={`user-image-${auth0_id}`} src={photo} className={classes.imgSmall} />
                    {isDrawerOpen && <div className={classes.titles}>
                        <Typography className={classes.title}>{firstname} {lastname}</Typography>
                        <Typography dir='auto' className={classes.subtitle}>
                            {title || ('@' + tag)}
                        </Typography>
                    </div>
                }
                {isDrawerOpen && <div className={classes.messageIcon} onClick={additionalOptions?.[0]?.onClick}>
                        <MessageButton />
                    </div>}
                </div>
                <div className={classes.divider} />
                {isDrawerOpen && <>
                    <div className={classes.about}>
                        <div className={classes.aboutText}>{t("About")}</div>
                    </div>
                    <div className={classes.bio}>
                        <div className={classes.bioText}>{bioText}</div>
                    </div>
                </>}
            {isDrawerOpen ? <Info/> : null}
            {/* { isDrawerOpen ? <div data-intrcm-id="UserInfoDrawer_ju5ek89c" className={classes.drawerButtons}> */}
          {/* {additionalOptions.map(el => {
            return (
              <Button onClick={el.onClick} className={el.title === "Message" ? classes.settingsButtonColored  : classes.settingsButton } >
                {el.title}
              </Button> 
            )
            })}
          </div> : <div data-intrcm-id="UserInfoDrawer_4694vy27" className={classes.drawerSmallButtons}> 
              {additionalOptions.map(el => (
                  <Tooltip
                            placement="right" 
                            title={<>
                                {el.title}
                                <div data-intrcm-id="UserInfoDrawer_725r1f7k" className={classes.triangle}></div>
                            </>  }
                            disableHoverListener={false} 
                            classes={{tooltip: classes.tooltip}}
                            onClick={el.onClick}
                            >
                            <div data-intrcm-id="UserInfoDrawer_vv9qrap3" className={el.title === "Message" ? classes.smallColoredButtonIcon : classes.smallButtonIcon}>
                             {el.title === "Message" && <MessageIcon color='white' /> }
                              {el.title === "Subscribe" && <SubscribeIcon color={theme.primary.b500} /> }
                              {el.title === "Unsubscribe" && <UnsubscribeIcon color={theme.primary.b500} /> }
                            </div>
                      </Tooltip>
                ))}
            </div> */}
            {/* } */}
        </div>
    )
}

const mapStateToProps = (state) => ({
    myAuth0_id: state.userData.profileData.auth0_id,
    cloudfront: state.globalData.cloudfront,
})

export const SelectedUserInfoDrawer = compose(
    withStyles(styles),
    withErrorCatcher("Failed loading User Info, Please Contact Tuqqi Support"),
    connect(mapStateToProps, null)
)(__SelectedUserInfoDrawer);